import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from 'lib/utils';
import { DropdownMenuItem } from 'components/ui/dropdown-menu';
/**
 * Radix focuses a menu item on every pointer move, and refocuses the menu
 * when the pointer leaves one. These rows look and act like buttons, so hover
 * only restyles them (as the old native buttons did) and never moves the
 * keyboard position or paints the focus ring. Pass as both onPointerMove and
 * onPointerLeave: preventDefault skips Radix's own handler.
 */
export var keepFocusOnHover = function (event) { return event.preventDefault(); };
/**
 * A producer bell row control registered with the Radix menu (SCO-487).
 * Native buttons inside DropdownMenuContent are unreachable by keyboard:
 * Radix focuses the content, blocks Tab and arrow-navigates registered items
 * only. Keeps the old button look; `cn` (tailwind-merge) overrides the item's
 * base padding, radius and highlight. `data-row-action` marks it as a control
 * for the bell's focus-after-acknowledge rule.
 */
var ProducerBellRowAction = function (_a) {
    var variant = _a.variant, onSelect = _a.onSelect, children = _a.children;
    return (_jsx(DropdownMenuItem, { "data-row-action": "", onSelect: onSelect, onPointerMove: keepFocusOnHover, onPointerLeave: keepFocusOnHover, className: cn(
        // focus-visible: no ring after a mouse click (focus still lands on
        // the item). ring-offset: --ring is the same coral as bg-primary, so a bare
        // ring would vanish into the Yes / Got it / Open fill.
        'cursor-pointer rounded-md px-3 py-1 text-xs font-semibold focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2', variant === 'primary' ?
            'bg-primary text-primary-foreground hover:opacity-90 focus:bg-primary focus:text-primary-foreground' :
            // border-solid: preflight is off, so `border` alone draws nothing —
            // the old native button got its outline from the legacy CSS.
            'border border-solid border-border hover:bg-black/5 focus:bg-black/5'), children: children }));
};
export default ProducerBellRowAction;
